import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-virtual-cash-register',
  templateUrl: './mcommerce-virtual-cash-register.component.html',
  styleUrls: ['./mcommerce-virtual-cash-register.component.scss']
})
export class McommerceVirtualCashRegisterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
